// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__8TMwN","paragraph":"Footer_paragraph__ZTYXs","link":"Footer_link__jlhDJ"};